export default {
  title01: "Aktuálne počasie",
  title02: "24 hodín",
  title03: "Zobraziť 10-dňovú predpoveď počasia",
  title04: "Index kvality ovzdušia",
  title05: "Zobraziť všetky informácie",
  title06: "VÝCHOD A ZÁPAD SLNKA",
  title07: "FÁZA MESIACA",
  title08: "Ďalší spln",
  title09: "Ďalší nov",
  title10: "DEŇ",
  title11: "NOC",
  title12: "Východ slnka",
  title13: "Západ slnka",
  title14: "Východ mesiaca",
  title15: "Západ mesiaca",
  title16: "Zdroj",
  title17: "Začiatok",
  title18: "Koniec",
  title19: "Použiť aktuálnu polohu",
  title20: "Vyhľadať mesto",
  title21: "Pocitová teplota",
  title22: "Pocitová teplota v tieni",
  title23: "Teraz",
  title24: "Dnes",
  title25: "NE",
  title26: "PON",
  title27: "UTO",
  title28: "STR",
  title29: "ŠTV",
  title30: "PIA",
  title31: "SOB",
  title32: "Načítava sa...",
  title33: "Teraz",
  title34: "Hodinová",
  title35: "Denná",
  title36: "Slnko a Mesiac",
  title37: "Kvalita ovzdušia",
  title38: "Kontakt: xlf550402@gmail.com",
  title39: "Dohoda o ochrane osobných údajov",
  title40: "Autorské práva © comfortweather.com 2020 - 2024. Všetky práva vyhradené.",
  title41: "Údaje poskytnuté",
  title42: "Max",
  title43: "Min",
  title44: "Súhlasiť",
  title45:
    "Ďakujeme, že používate ComfortWeather! Pre lepšiu ochranu vašich práv a záujmov si pred použitím pozorne prečítajte ",
  title46: "Zásady ochrany osobných údajov",
  title47: " .",
  title48: "",
  title49: "Kontakt: xyjph123@gmail.com",
  title50: "Autorské práva © 24hweather.com 2020 - 2024. Všetky práva vyhradené.",
  title51:
    "Ďakujeme, že používate 24hweather! Pre lepšiu ochranu vašich práv a záujmov si pred použitím pozorne prečítajte ",
};
